import { DividerStyled, ObjectiveItemRightStyled, ObjectivesContainerStyled, ObjectiveItemLeftStyled } from "@/components/missions-render-v2/style-component";
import RenderBenefit from "@/components/missions-render-v2/components/render-benefit/render-benefit";
import { ContainerShowAndHide, TitleStyled } from "@/components/section-with-headings/style-components";
import { MissionComponentProps, MissionTypeCampaign, MissionTypeObjective, ObjectiveComponentProps, WinnersProps } from "@/components/missions-render-v2/missions-render-types";
import { useMission } from "@/hook/useMission/useMission";
import { LoaderContainer } from "@/pages/campaign-page/style-component";
import { SpaceshipLoader } from "@/components/spaceship-loader/spaceship-loader";
import React, { memo, useState } from "react";
import { Objective } from "@/types/objective/objective-type";
import MissionSocialMedia from "@/components/missions-render-v2/components/objective-social-media/objective-social-media";
import { TimeInfo } from "@/components/time-info/time-info";
import RequirementsObjective from "@/components/missions-render-v2/components/requirements-objective/requirements-objective";
import { useUserContext } from "@/contexts/user/useUserContext";
import ExpiredMission from "@/components/expired-mission/expired-mission";

const TYPE_OBJECTIVE: Record<MissionTypeObjective | 'CONTEST', MissionTypeCampaign | 'CONTEST'> = {
	FILL_OUT_SV: 'SURVEY',
	GET_SV_POINTS: 'SURVEY',
	GET_LIKES: 'SOCIAL_MEDIA',
	GET_COMMENTS: 'SOCIAL_MEDIA',
	GET_SHARES: 'SOCIAL_MEDIA',
	GET_VIEWS: 'SOCIAL_MEDIA',
	MAKE_POST: 'SOCIAL_MEDIA',
	CONNECT: 'SOCIAL_MEDIA',
	EXCHANGE: 'EXCHANGE',
	CONTEST: 'CONTEST',
};

const RenderObjective: React.FC<ObjectiveComponentProps> = memo(({ objective, ...props }) => {
	const { type } = objective;
	const newType = type?.split(':')[0] ?? '';
	const typeObjectiveCampaign = TYPE_OBJECTIVE?.[newType as MissionTypeObjective] ?? null;
	if (!typeObjectiveCampaign) {
		return <div style={{ color: 'white' }}>Type objective {newType} not supported</div>;
	}
	return (
		<MissionSocialMedia
			{...props}
			objective={objective}
		/>
	)
})

const MissionContest: React.FC<MissionComponentProps> = ({ mission, participant, campaign, requirements }) => {
	const { user } = useUserContext();
	const { description, end_date, start_date } = mission;
	const now = Math.floor(Date.now() / 1000);
	const isExpiredMission = now > end_date;
	const isComingSoon = now < start_date;
	const benefits = mission?.benefits ?? [];
	const [completedRequirements, setCompletedRequirements] = useState(requirements?.length === 0);
	const { isCompleted, loadingProgress, missionState, getProgress } = useMission(mission, participant);
	const [winners, setWinners] = useState<WinnersProps[]>([]);
	const [isClaimed, setIsClaimed] = useState<boolean>(false);
	const [isValidateClaim, setIsValidateClaim] = useState<boolean>(false);
	const filterWinner = winners?.filter((item)=> String(user?.main_key).toUpperCase() === String(item?.main_key).toUpperCase() && item?.isWinner);
	const isCompleteAndEndMission = isCompleted && now > end_date && filterWinner?.length > 0;
	
	const determineStatus = () => {
		if (!isClaimed && isCompleteAndEndMission) return 'pending_claim';
		if (isClaimed && isCompleteAndEndMission) return 'completed';
		if (now > end_date) return 'expired';
		if (now < start_date) return 'comingUp';
		return 'inCourse';
	}
	const status = determineStatus();

	if (loadingProgress) {
		return (
			<LoaderContainer>
				<SpaceshipLoader height="150px" />
			</LoaderContainer>
		)
	}

	return (
		<ObjectivesContainerStyled>
			<ObjectiveItemLeftStyled>
				<TitleStyled className="titleBenefit">{description}</TitleStyled>
				<RenderBenefit
					benefits={benefits}
					participant={participant}
					isCompleted={isCompleteAndEndMission}
					mission={missionState}
					typeObjective={''}
					setIsClaimed={setIsClaimed}
					setIsValidateClaim={setIsValidateClaim}
				/>
				<TimeInfo
					isCampaign={false}
					endDate={missionState.end_date}
					startDate={missionState.start_date}
					status={status}
				/>
			</ObjectiveItemLeftStyled>
			<DividerStyled />
			<ObjectiveItemRightStyled>
				{!isCompleteAndEndMission && requirements?.length > 0 && !completedRequirements &&
				<RequirementsObjective
					requirements={requirements}
					setCompletedRequirements={setCompletedRequirements}
				/>}
				{!isCompleteAndEndMission && isExpiredMission && !loadingProgress &&
					<ExpiredMission />
				}
				<ContainerShowAndHide $endMission={!isCompleteAndEndMission && isExpiredMission}>
					<TitleStyled>Objetivos</TitleStyled>
					{missionState?.objectives?.map((objective: Objective, position: number) => (
						<RenderObjective
							key={objective.id}
							mission={mission}
							objective={objective}
							participant={participant}
							campaign={campaign}
							getProgress={getProgress}
							isExpiredMission={isExpiredMission}
							isComingSoon={isComingSoon}
							isCompleted={isCompleteAndEndMission}
							loadingProgress={loadingProgress}
							completedRequirements={true}
							position={position + 1}
							setWinners={setWinners}
							disabledMission={isValidateClaim}
						/>
					))}
				</ContainerShowAndHide>
			</ObjectiveItemRightStyled>
		</ObjectivesContainerStyled>
	)
}

export default MissionContest;